import * as React from 'react'

import { Button, TYPE } from 'components/Button'
import Icon from 'components/Icon'
import { UI } from 'Icon/ui'
import { DefaultContent } from 'react-content-engine'

import './ModalHeader.scss'

interface HeaderProps {
  icon?: JSX.Element
  iconProps?: object
  onDismiss?: () => void
  backButton?: boolean
  children?: React.ReactNode | undefined
}

const ModalHeader: React.FC<HeaderProps> = props => {
  return (
    <header>
      {props.icon ? (
        <span className="icon">
          <Icon icon={props.icon} {...props?.iconProps} />
        </span>
      ) : null}

      {props.backButton ? (
        <Button type={TYPE.inlinetext} onClick={props.onDismiss}>
          <Icon icon={UI.arrowLeft} />
          <span>
            <DefaultContent contentKey="back">Back</DefaultContent>
          </span>
        </Button>
      ) : null}

      <span className="title">{props.children}</span>

      <span className="close" onClick={props.onDismiss}>
        <Icon icon={UI.close} />
      </span>
    </header>
  )
}

export { ModalHeader }
